import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const r = await login(username, password);
    setSubmitting(false);
    if (r.ok) { toast.success("Welcome back!"); nav("/admin"); }
    else toast.error(r.error || "Invalid credentials");
  };

  return (
    <div className="min-h-screen bg-maroon grid place-items-center p-4 relative overflow-hidden">
      <div className="absolute inset-0 grain pointer-events-none opacity-40" />
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md p-8">
        <Link to="/" className="flex items-center gap-3 mb-8">
          <img src="/icon-white.jpg" alt="Global Compass" className="w-11 h-11 rounded-full" />
          <div className="leading-tight">
            <div className="font-display text-lg font-bold text-maroon">Global Compass</div>
            <div className="text-xs tracking-widest uppercase text-amber-800 font-semibold">Admin Portal</div>
          </div>
        </Link>
        <h1 className="font-display text-3xl font-bold text-maroon mb-2">Admin Portal</h1>
        <p className="text-slate-600 mb-6">Manage tours, inquiries and testimonials.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2">Username</label>
            <input required type="text" autoCapitalize="none" autoCorrect="off" spellCheck="false" value={username} onChange={(e)=>setUsername(e.target.value)}
              className="w-full h-12 px-4 rounded-lg border-2 border-amber-900/15 focus:border-amber-600 focus:outline-none bg-ivory text-base" data-testid="admin-login-username"/>
          </div>
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2">Password</label>
            <input required type="password" value={password} onChange={(e)=>setPassword(e.target.value)}
              className="w-full h-12 px-4 rounded-lg border-2 border-amber-900/15 focus:border-amber-600 focus:outline-none bg-ivory text-base" data-testid="admin-login-password"/>
          </div>
          <button type="submit" disabled={submitting} className="btn-gold w-full h-12 rounded-full font-bold text-base disabled:opacity-60" data-testid="admin-login-submit">
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <Link to="/" className="block mt-6 text-center text-sm text-slate-500 hover:text-maroon">← Back to site</Link>
      </div>
    </div>
  );
}
